/**
 * Core marketing and app theme - clean enterprise fintech styling
 */
import { createTheme } from '@mui/material/styles';

const fontFamily = 'var(--font-sans)';
const displayFamily = 'var(--font-display)';

export const theme = createTheme({
  palette: {
    primary: { main: '#0f6fff' },
    secondary: { main: '#0b57d0' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b' },
  },
  typography: {
    fontFamily,
    h1: { fontFamily: displayFamily, fontSize: '2.25rem', fontWeight: 300, lineHeight: 1.12, letterSpacing: '-0.01em' },
    h2: { fontFamily: displayFamily, fontSize: '1.75rem', fontWeight: 300, lineHeight: 1.14, letterSpacing: '-0.005em' },
    h3: { fontFamily: displayFamily, fontSize: '1.25rem', fontWeight: 400, lineHeight: 1.2, letterSpacing: '0' },
    body1: { fontFamily, fontSize: '1rem', lineHeight: 1.6, fontWeight: 400 },
    body2: { fontFamily, fontSize: '0.875rem', lineHeight: 1.6, fontWeight: 400 },
    button: { fontFamily },
    caption: { fontFamily },
    overline: { fontFamily },
    subtitle1: { fontFamily },
    subtitle2: { fontFamily },
  },
  shape: { borderRadius: 8 },
  spacing: 8,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { fontFamily },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { fontFamily, textTransform: 'none', fontWeight: 400 },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
  },
});
